import React from 'react';
import PropTypes from 'prop-types';
import { FieldArray, reduxForm } from 'redux-form';
import TextCropper from '@omilia/text-cropper';

import Form from 'components/Form';
import Button from 'components/Button';
import FORM_NAMES from 'constants/formNames';

import { dictionaryType } from 'types';
import ColumnField from './components/ColumnField';

import './style.scss';

export const Columns = ({
  onClose,
  onSubmit,
  dictionary,
  handleSubmit,
  submitting,
}) => (
  <Form onSubmit={handleSubmit(onSubmit)}>
    <div styleName="wrap">
      <div styleName="header">
        <span>
          <TextCropper styleName="cropper" text={dictionary.name} />
        </span>
        <Button
          isLink
          className="icon-close"
          data-test="close"
          onClick={onClose}
        />
      </div>

      <div styleName="list">
        <FieldArray
          component={ColumnField}
          fields={dictionary.columns}
          name="dictionary_columns"
        />
      </div>
      <div styleName="footer">
        <Button isSmall isTransparent onClick={onClose}>
          Cancel
        </Button>
        <Button isSmall isLoading={submitting} type="submit">
          Add
        </Button>
      </div>
    </div>
  </Form>
);

Columns.propTypes = {
  dictionary: dictionaryType,
  handleSubmit: PropTypes.func,
  submitting: PropTypes.bool,

  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default reduxForm({
  form: FORM_NAMES.TEST_SETS.ADD_TO_DICTIONARY,
})(Columns);
